export default {
  floatRight: { float: "right" },
};
